import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PageService } from 'src/app/services/page/page.service';
import { RouteGeneratorService } from 'src/app/services/route-generator/route-generator.service';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';
import { CommonModule } from '@angular/common';
import { EmbeddedAlertComponent } from '../../../shared/embedded-alert/embedded-alert.component';
import { LoadingSpinnerComponent } from '../../../shared/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [
    CommonModule,
    EmbeddedAlertComponent,
    LoadingSpinnerComponent,
    ReactiveFormsModule,
  ],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  error!: string | null;
  isLoading!: boolean;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private pageService: PageService,
    private routeGenerator: RouteGeneratorService,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }
    const { username, password } = this.loginForm.value;
    this.isLoading = true;

    console.log('🔐 LOGIN DEBUG: Starting login process for user:', username);

    this.authService.login(username, password).subscribe(
      (res: LoginResponseData) => {
        console.log('🔐 LOGIN DEBUG: Login response received:', res);

        if (res.status == 1) {
          this.isLoading = false;
          console.log('🔐 LOGIN DEBUG: User authenticated successfully (status 1), redirecting to first survey page');

          // Use AuthService to properly redirect to first survey page
          this.authService.redirectAuthenticatedUser();
        } else if (res.status == 2) {
          console.log('🔐 LOGIN DEBUG: User needs password change (status 2)');
          this.isLoading = false;
          this.authService.oldPassword.next(password);
          this.router.navigate(['requirepasswordchange']);
        } else {
          console.log('🔐 LOGIN DEBUG: Unexpected status:', res.status);
        }
      },
      (errorMessage: any) => {
        console.error('🔐 LOGIN DEBUG: Login error:', errorMessage);
        if (errorMessage) {
          this.isLoading = false;
          this.error = 'Invalid Login';
        }
      },
    );
  }

  goToPasswordRecovery(): void {
    this.router.navigate(['recoverpassword']);
  }
}
